import React, { Component } from 'react'
import _ from 'lodash'
import { Link, withRouter } from 'react-router-dom'
import moment from 'moment'
import { observer } from 'mobx-react'
import { Row, Col, Skeleton, Empty } from 'antd'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import ConstituentAvatar from '../../components/Custom/ConstituentAvatar'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { match, history } = this.props
		const blotter_uid = _.has(match.params, 'blotter_uid') ? match.params.blotter_uid : null
		if (!blotter_uid) return history.push('/blotter')

		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Katarungan Pambarangay</a></li>
									<li className="breadcrumb-item"><Link to='/blotter'>Blotter</Link></li>
									<li className="breadcrumb-item active">Blotter Details</li>
								</ol>
							</div>
							<h4 className="page-title">Blotter Details</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Query
									query={BLOTTER_BY_UID}
									variables={{ blotter_uid }}
									fetchPolicy='network-only'
								>
									{({ loading, error, data }) => {
										console.log('blotter', blotter)
										if (loading) return <Skeleton active/>
										if (error) return <Empty />

										let blotter = _.has(data,'barangayBlotterByUid') ? data.barangayBlotterByUid : {}
										//console.log('blotter', blotter)
										return (
											<React.Fragment>
												<Row style={{ padding: 10, border: '1px solid #ccc', borderRadius: 16 }}>
													{
														blotter.complainants.map((i, key) => (
															<React.Fragment key={key}>
																<Row gutter={24} style={{ marginTop: 10 }}>
																	<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Complainant {(key + 1)}</h4></Col>
																	<Col md={16} sm={12}>
																		{/* {
																			i.complainant_ref_uid &&
																		<ConstituentAvatar style={{ marginRight: 15 }} size={50}  constituent_uid={i.complainant_ref_uid}/>
																		} */}
																		<h4>{i.complainant_name}</h4>
																	</Col>
																</Row>
																<Row gutter={24} style={{ marginTop: 10 }}>
																	<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Complainant {(key + 1)} Address</h4></Col>
																	<Col md={16} sm={12}><h4>{i.complainant_address}</h4></Col>
																</Row>
															</React.Fragment>
														))
													}
												</Row>
												<Row style={{ marginTop: 10, padding: 10, border: '1px solid #ccc', borderRadius: 16 }}>
													{
														blotter.respondents.map((i, key) => (
															<React.Fragment key={key}>
																<Row gutter={24} style={{ marginTop: 10 }}>
																	<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Respondent {(key + 1)}</h4></Col>
																	<Col md={16} sm={12}>
																		{/* {
																			i.respondent_ref_uid &&
																		<ConstituentAvatar style={{ marginRight: 15 }} size={50}  constituent_uid={i.respondent_ref_uid}/>
																		} */}
																		<h4>{i.respondent_name}</h4>
																	</Col>
																</Row>
																<Row gutter={24} style={{ marginTop: 10 }}>
																	<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Respondent {(key + 1)} Address</h4></Col>
																	<Col md={16} sm={12}><h4>{i.respondent_address}</h4></Col>
																</Row>
															</React.Fragment>
														))
													}
												</Row>
												<Row gutter={24} style={{ marginTop: 10 }}>
													<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Remarks</h4></Col>
													<Col md={16} sm={12}><h4>{blotter.remarks}</h4></Col>
												</Row>
												<Row gutter={24} style={{ marginTop: 10 }}>
													<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Date Filed</h4></Col>
													<Col md={16} sm={12}><h4>{moment(blotter.created_at).format('lll')}</h4></Col>
												</Row>
											</React.Fragment>
										)
									}}
								</Query>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
    
    
}

const BLOTTER_BY_UID = gql`
    query barangayBlotterByUid($blotter_uid: String) {
		barangayBlotterByUid(blotter_uid: $blotter_uid)
    }
`

const composed = compose(
	withRouter,
	observer
)

export default composed(Index)